import { ref } from 'vue'

// Global toast state - simplified approach
const toasts = ref([])
let toastId = 0

export function useToast() {
  const addToast = (type, title, message = '', duration = 8000) => {
    // Prevent duplicate toasts that are currently visible
    const existingToast = toasts.value.find(toast => 
      toast.type === type && toast.title === title && toast.message === message
    )
    
    if (existingToast) {
      return existingToast.id
    }
    
    const id = ++toastId
    const toast = {
      id,
      type,
      title,
      message
    }
    
    toasts.value.push(toast)
    
    // Auto remove toast after duration
    if (duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, duration)
    }
    
    return id
  }
  
  const removeToast = (id) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }
  
  const clearAllToasts = () => {
    toasts.value = []
  }
  
  // Convenience methods
  const showSuccess = (title, message, duration = 8000) => {
    return addToast('success', title, message, duration)
  }
  
  const showError = (title, message, duration = 8000) => {
    return addToast('error', title, message, duration)
  }
  
  const showWarning = (title, message, duration) => addToast('warning', title, message, duration)
  const showInfo = (title, message, duration) => addToast('info', title, message, duration)
  
  return {
    toasts,
    addToast,
    removeToast,
    clearAllToasts,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
}
